import { useLayoutEffect } from "react";
import { useDispatch } from "react-redux";
import {
    clearInspirationBulkSnapshot,
    getPendingInspirationUploadIds,
    readInspirationBulkSnapshot,
} from "../service/inspiration-gallery-upload-session";
import { waitForInspirationGalleryUploadDone } from "../service/inspiration-gallery-upload-sse";
import { restoreBulkGalleryJob } from "../store/uploadProgress/uploadProgressSlice";

/**
 * After a full page reload, reconnect to any in-progress inspiration gallery uploads.
 * useLayoutEffect runs before paint so the progress bar does not flash empty.
 */
export function useRestoreInspirationUploadProgress() {
    const dispatch = useDispatch();

    useLayoutEffect(() => {
        const ids = getPendingInspirationUploadIds();
        if (!ids.length) {
            clearInspirationBulkSnapshot();
            return;
        }

        const snap = readInspirationBulkSnapshot();
        const bulkMode = !!(snap && snap.total > 0);

        if (bulkMode) {
            dispatch(
                restoreBulkGalleryJob({
                    total: snap.total,
                    completed: Math.min(snap.total, snap.completed ?? 0),
                    currentIndex: snap.currentIndex ?? 0,
                    currentTitle: snap.currentTitle ?? "",
                    currentFile: "Reconnecting…",
                    currentPercent: 0,
                })
            );
        }

        ids.forEach((uploadId) => {
            waitForInspirationGalleryUploadDone(uploadId, dispatch, {
                persistSession: false,
                refreshListOnDone: true,
                bulkGalleryMode: bulkMode,
            }).catch(() => {
                /* Session cleared in waitFor on permanent SSE failure */
            });
        });
    }, [dispatch]);
}
